import {
  init_sceneUboDeclaration
} from "./chunk-MSUM6M2W.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/backgroundUboDeclaration.js
var name, shader;
var init_backgroundUboDeclaration = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/backgroundUboDeclaration.js"() {
    "use strict";
    init_shaderStore();
    init_sceneUboDeclaration();
    name = "backgroundUboDeclaration";
    shader = `layout(std140,column_major) uniform;uniform Material
{uniform vec4 vPrimaryColor;uniform vec4 vPrimaryColorShadow;uniform vec2 vDiffuseInfos;uniform vec2 vReflectionInfos;uniform mat4 diffuseMatrix;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;uniform float fFovMultiplier;uniform float pointSize;uniform float shadowLevel;uniform float alpha;uniform vec3 vBackgroundCenter;uniform vec4 vReflectionControl;uniform vec2 projectedGroundInfos;};
#include<sceneUboDeclaration>
`;
    ShaderStore.IncludesShadersStore[name] = shader;
  }
});

export {
  init_backgroundUboDeclaration
};
